<template>
    <el-row>
        <el-form :model="StationAuthInfoDetailForm"
                 :rules="rules"
                 @onSelectInfo="onSelectInfo"
                 addAction=""
                 editAction="/gasStation/updateGasStation.action"
                 label-width="150px"
                 ref="StationAuthInfoModifyRef"
                 selectAction="/gasStation/getGasStationDetail.action"
                 style="width:50%"
                 v-form>

            <el-divider content-position="left"><strong>基础信息</strong></el-divider>
            <el-form-item label="公众号授权链接" prop="publicWeChatUrl">
                <el-input :disabled="true" placeholder="授权链接"
                          v-model="StationAuthInfoDetailForm.publicWeChatUrl"></el-input>
            </el-form-item>
            <el-form-item label="商户号" prop="mchId">
                <el-input placeholder="商户号" v-model="StationAuthInfoDetailForm.mchId"></el-input>
            </el-form-item>
            <el-form-item label="加油站名称" prop="gasStationName">
                <el-input placeholder="加油站名称" v-model="StationAuthInfoDetailForm.gasStationName"></el-input>
            </el-form-item>

            <el-form-item label="加油站地址" prop="detailAddress">
                <search-address-input :defaultValue="StationAuthInfoDetailForm.detailAddress" @onChenged="onChange"
                                      placeholder="请选择（支持搜索联想输入）"
                                      ref="business-address"
                                      v-model="StationAuthInfoDetailForm.detailAddress"></search-address-input>
            </el-form-item>

            <el-form-item label="封面照" prop="image">
                <el-upload :data="{floder:'gasStation'}" :http-request="onHttpRequest"
                           :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.img">
                    <img :src="StationAuthInfoDetailForm.img.url" class="avatar" v-if="StationAuthInfoDetailForm.img">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="营业执照照片" prop="businessLicense">
                <el-upload :data="{floder:'gasStation'}" :disabled="false"
                           :http-request="onHttpRequest" :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.businessLicense">
                    <img :src="StationAuthInfoDetailForm.businessLicense.url"
                         class="avatar" v-if="StationAuthInfoDetailForm.businessLicense">

                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="特殊资质" prop="qualificationsImg">
                <el-upload :data="{floder:'gasStation'}" :disabled="false"
                           :http-request="onHttpRequest" :show-file-list="false"
                           accept="image/*" action="upload/uploadPic"
                           class="avatar-uploader" v-model="StationAuthInfoDetailForm.qualificationsImg">
                    <img :src="StationAuthInfoDetailForm.qualificationsImg.url"
                         class="avatar" v-if="StationAuthInfoDetailForm.qualificationsImg">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>

            <el-divider content-position="left"><strong>法人信息</strong></el-divider>

            <el-form-item label="法人身份证正面" prop="legalFrontCard">
                <el-upload :data="{floder:'gasStation'}" :disabled="false" :http-request="onHttpRequest"
                           :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.legalFrontCard">

                    <img :src="StationAuthInfoDetailForm.legalFrontCard.url" class="avatar"
                         v-if="StationAuthInfoDetailForm.legalFrontCard">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="法人身份证反面" prop="legalReverseCard">
                <el-upload :data="{floder:'gasStation'}" :disabled="false"
                           :http-request="onHttpRequest" :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.legalReverseCard">
                    <img :src="StationAuthInfoDetailForm.legalReverseCard.url" class="avatar"
                         v-if="StationAuthInfoDetailForm.legalReverseCard">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>

            <el-divider content-position="left"><strong>经营者信息</strong></el-divider>
            <el-form-item label="经营者姓名" prop="gasStationLeaderName">
                <el-input :disabled="false" placeholder="经营者姓名"
                          v-model="StationAuthInfoDetailForm.gasStationLeaderName"></el-input>
            </el-form-item>
            <el-form-item label="经营者手机" prop="gasStationLeaderPhone">
                <el-input :disabled="true" placeholder="经营者手机"
                          v-model="StationAuthInfoDetailForm.gasStationLeaderPhone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱账号" prop="email">
                <el-input :disabled="false" placeholder="邮箱账号" v-model="StationAuthInfoDetailForm.email"></el-input>
            </el-form-item>
            <el-form-item label="经营者身份证正面" prop="frontCard">
                <el-upload :data="{floder:'gasStation'}" :disabled="false" :http-request="onHttpRequest"
                           :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.frontCard">

                    <img :src="StationAuthInfoDetailForm.frontCard.url" class="avatar"
                         v-if="StationAuthInfoDetailForm.frontCard">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="经营者身份证反面" prop="image">
                <el-upload :data="{floder:'gasStation'}" :disabled="false"
                           :http-request="onHttpRequest" :show-file-list="false"
                           accept="image/*" action="upload/uploadPic" class="avatar-uploader"
                           v-model="StationAuthInfoDetailForm.reverseCard">
                    <img :src="StationAuthInfoDetailForm.reverseCard.url" class="avatar"
                         v-if="StationAuthInfoDetailForm.reverseCard">
                    <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    <div class="el-upload__tip" slot="tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p>
                    </div>
                </el-upload>
            </el-form-item>
            <el-divider content-position="left"><strong>结算账户</strong></el-divider>
            <el-form-item label="开户名称" prop="accountName">
                <el-input :disabled="false" placeholder="开户名称"
                          v-model="StationAuthInfoDetailForm.accountName"></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="bankName">
                <el-input :disabled="false" placeholder="开户行" v-model="StationAuthInfoDetailForm.bankName"></el-input>
            </el-form-item>
            <el-form-item label="开户支行" prop="accountOpeningBranch">
                <el-input :disabled="false" placeholder="开户支行"
                          v-model="StationAuthInfoDetailForm.accountOpeningBranch"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="bankCardNumber">
                <el-input :disabled="false" placeholder="银行账号"
                          v-model="StationAuthInfoDetailForm.bankCardNumber"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">返回</el-button>
                <el-button type="primary">保存</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import SearchAddressInput from '@/components/SearchAddressInput'
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'StationAuthInfoModify',
  extends: BasicPager,
  components: { SearchAddressInput },
  data: function () {
    return {
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      StationAuthInfoDetailForm: {
        id: null
      },
      rules: {
        gasStationName: [{
          required: true,
          message: '加油站不能为空！'
        }],
        detailAddress: [{
          required: true,
          message: '地址不能为空！'
        }],
        img: [{
          required: true,
          trigger: 'change',
          message: '封面照不能为空！'
        }],
        businessLicense: [{
          required: true,
          message: '营业执照照片不能为空！'
        }],
        qualificationsImg: [{
          required: true,
          message: '特殊资质不能为空！'
        }],
        gasStationLeaderName: [{
          trigger: 'change',
          required: true,
          message: '经营者姓名不能为空！'
        }],
        email: [{
          required: true,
          message: '邮箱不能为空！'
        }],
        legalFrontCard: [{
          required: true,
          message: '法人身份证正面不能为空'
        }],
        legalReverseCard: [{
          required: true,
          message: '法人身份证反面不能为空'
        }],
        frontCard: [{
          required: true,
          message: '经营者身份证正面不能为空'
        }],
        reverseCard: [{
          required: true,
          message: '经营者身份证反面不能为空'
        }],
        accountName: [{
          required: true,
          message: '开户名称不能为空'
        }],
        bankName: [{
          required: true,
          message: '开户行不能为空'
        }],
        accountOpeningBranch: [{
          required: true,
          message: '开户支行不能为空'
        }],
        bankCardNumber: [{
          required: true,
          message: '银行账号不能为空'
        }]
      }
    }
  },
  created () {
    this.StationAuthInfoDetailForm.id = this.$route.query.id
  },
  methods: {
    onChange: function (addressInfo) {
      // 查询省市区areaCode
      // this.form.address = addressInfo.value

      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county
      this.StationAuthInfoDetailForm.city = city
      let location = addressInfo.location.split(',')
      this.StationAuthInfoDetailForm.detailAddress = addressInfo.value
      this.StationAuthInfoDetailForm.longitude = location[0]
      this.StationAuthInfoDetailForm.latitude = location[1]
    },
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
